// src/services/assets.js (recommendations)
import api from './api';

/**
 * Service for managing OT assets
 */
const assetsService = {
  /**
   * Get all assets with optional filters
   * @param {Object} filters - Filter parameters (asset_type, location, vendor, skip, limit)
   * @returns {Promise<Array>} - List of assets
   */
  getAssets: async (filters = {}) => {
    try {
      const response = await api.get('/assets/', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Error fetching assets:', error);
      throw error;
    }
  },

  /**
   * Get a single asset by ID
   * @param {string} assetId - Asset ID
   * @returns {Promise<Object>} - Asset details
   */
  getAsset: async (assetId) => {
    try {
      const response = await api.get(`/assets/${assetId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching asset ${assetId}:`, error);
      throw error;
    }
  },

  /**
   * Create a new asset
   * @param {Object} assetData - Asset data
   * @returns {Promise<Object>} - Created asset
   */
  createAsset: async (assetData) => {
    try {
      const response = await api.post('/assets/', assetData);
      return response.data;
    } catch (error) {
      console.error('Error creating asset:', error);
      throw error;
    }
  },

  /**
   * Update an existing asset
   * @param {string} assetId - Asset ID
   * @param {Object} assetData - Updated asset data
   * @returns {Promise<Object>} - Updated asset
   */
  updateAsset: async (assetId, assetData) => {
    try {
      const response = await api.put(`/assets/${assetId}`, assetData);
      return response.data;
    } catch (error) {
      console.error(`Error updating asset ${assetId}:`, error);
      throw error;
    }
  },

  /**
   * Delete an asset
   * @param {string} assetId - Asset ID
   * @returns {Promise<void>}
   */
  deleteAsset: async (assetId) => {
    try {
      await api.delete(`/assets/${assetId}`);
    } catch (error) {
      console.error(`Error deleting asset ${assetId}:`, error);
      throw error;
    }
  }
};

export { assetsService };
export default assetsService;
